import React from 'react';
import { cn } from '../../lib/utils';

export interface GlassCardProps extends React.HTMLAttributes<HTMLDivElement> {
  glow?: 'cyan' | 'purple' | 'emerald' | 'amber' | 'none';
  interactive?: boolean;
}

export function GlassCard({
  glow = 'cyan',
  interactive = false,
  className,
  children,
  ...props
}: GlassCardProps) {
  const glowClasses = {
    cyan: 'hover:shadow-[0_0_25px_rgba(6,182,212,0.25)] hover:border-cyan-500/40',
    purple: 'hover:shadow-[0_0_25px_rgba(168,85,247,0.25)] hover:border-purple-500/40',
    emerald: 'hover:shadow-[0_0_25px_rgba(16,185,129,0.25)] hover:border-emerald-500/40',
    amber: 'hover:shadow-[0_0_25px_rgba(245,158,11,0.25)] hover:border-amber-500/40',
    none: '',
  };

  return (
    <div
      className={cn(
        'relative rounded-2xl border border-white/10 dark:border-zinc-800/80',
        'bg-white/80 dark:bg-zinc-900/60 backdrop-blur-xl shadow-xl',
        'transition-all duration-300 overflow-hidden',
        interactive && 'cursor-pointer transform hover:-translate-y-1',
        glow !== 'none' && glowClasses[glow],
        className
      )}
      {...props}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-white/0 dark:from-white/5 dark:to-transparent pointer-events-none" />
      {children}
    </div>
  );
}
